"use client";

// Re-export everything from theme.ts (which itself re-exports sub-modules)
export {
  theme,
  colors,
  sharedColors,
  sharedTheme,
  sizes,
  borderRadius,
  spacing,
  padding,
  iconSizes,
  avatarSizes,
  breakpoints,
  mediaQueries,
  mediaQueriesValues,
  layoutPadding,
  fontFamily,
  fontWeights,
  typographyVariants,
  typography,
  GlobalStyle,
} from "./theme";

export type { Theme } from "./theme";
export type { Colors, ColorPrimitives, SemanticColors, Shadows } from "./colors";
export type { Sizes } from "./sizes";
export type { Breakpoints, MediaQueries } from "./mediaQueries";
export type { Typography, TypographyVariant } from "./typography";

// ---------------------------------------------------------------------------
// Utility hooks - responsive breakpoint detection
// Uses MUI's useMediaQuery for SSR-safe breakpoint checks.
// ---------------------------------------------------------------------------
import { useMediaQuery } from "@mui/material";
import { breakpoints as bp } from "./mediaQueries";

/**
 * Returns true when viewport is at or above the desktop breakpoint.
 */
export function useIsDesktop(): boolean {
  return useMediaQuery(`(min-width: ${bp.lg}px)`);
}

/**
 * Returns true when viewport is below the tablet breakpoint (mobile only).
 */
export function useIsMobile(): boolean {
  return useMediaQuery(`(max-width: ${bp.md - 1}px)`);
}

/**
 * Returns true when viewport is between tablet and desktop breakpoints.
 */
export function useIsTablet(): boolean {
  return useMediaQuery(
    `(min-width: ${bp.md}px) and (max-width: ${bp.lg - 1}px)`
  );
}

/**
 * Returns true when viewport is at or above the large desktop breakpoint.
 */
export function useIsLargeDesktop(): boolean {
  return useMediaQuery(`(min-width: ${bp.xl}px)`);
}
